// import React from "react";

// export default function LoadingSpinner({ size = "default" }) {
//   const sizeClasses = {
//     small: "w-5 h-5",
//     default: "w-8 h-8",
//     large: "w-12 h-12"
//   };

//   return (
//     <div className="flex items-center justify-center py-8">
//       <div className={`${sizeClasses[size]} animate-spin rounded-full border-3 border-red-200 border-t-red-600`} />
//     </div>
//   );
// }



// components/common/LoadingSpinner.jsx
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

export default function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      >
        <Loader2 className="w-12 h-12 text-red-600" />
      </motion.div>
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="text-red-700 font-medium animate-pulse"
      >
        טוען נתונים...
      </motion.p>
    </div>
  );
}